export const CTI_STAFFING_BUSINESS_ENTITY_ID = 1
export const ALL_BUSINESS_ENTITIES = -1
